import(/* webpackMode: "eager" */ "/home/runner/work/integrations-monorepo/integrations-monorepo/apps/go-high-level/src/app/global-error.tsx");
